import styled from 'styled-components';

export const ContainerNorlys = styled.div({
  margin: '20px 0 20px',
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'center',
  width: '100%',
});
